export default "__VITE_ASSET__BaXUQYQH__"